import React from 'react';

export default function PageHeader({ title, subtitle, actions, breadcrumb }) {
  return (
    <div className="page-header" data-testid="page-header">
      <div style={{ minWidth: 0 }}>
        {breadcrumb && (
          <div className="text-muted" style={{ fontSize: '0.82rem', marginBottom: 4 }}>
            {breadcrumb}
          </div>
        )}
        <h1 data-testid="page-title">{title}</h1>
        {subtitle && <div className="subtitle">{subtitle}</div>}
      </div>
      {actions && <div className="d-flex gap-2 align-items-center">{actions}</div>}
    </div>
  );
}
